import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import mailImg from "../../images/contactMail.svg";

const Contact = () => {
  const { trackPageView } = useMatomo();

  useEffect(() => {
    trackPageView({
      documentTitle: "Contact Us",
      href: "/contact",
    });
  }, [trackPageView]);

  const [contactFormValues, setContactFormValues] = useState({
    name: "",
    email: "",
    role: "",
    institution: "",
  });

  const handleChange =
    (name) =>
    ({ target: { value } }) => {
      setContactFormValues({
        ...contactFormValues,
        [name]: value,
      });
    };

  const handleFormSubmit = (event) => {
    event.preventDefault();
  };

  const openEmailClientsWithDetails = () => {
    let mail = document.createElement("a");
    mail.href = `mailto:mtxpk@cchmc.org?subject=I would like to know more about MTXPK.org!&body=Please find my details below: %0D%0A Name: ${contactFormValues.name} %0D%0A EMAIL: ${contactFormValues.email} %0D%0A ROLE: ${contactFormValues.role} %0D%0A INSTITUTION: ${contactFormValues.institution}`;
    mail.click();
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: "800px",
        width: "100%",
        overflow: { lg: "hidden" },
      }}
    >
      <Grid item>
        <Box
          component="form"
          autoComplete="off"
          onSubmit={handleFormSubmit}
          sx={{
            position: "relative",
            pt: { xs: 2, sm: 6 },
            width: { xs: "100%", sm: "auto" },
            backgroundColor: "transparent",
          }}
        >
          <Box
            component="img"
            src={mailImg}
            alt="mail icon"
            sx={{
              display: { xs: "none", lg: "block" },
              position: "absolute",
              top: -37,
              right: -91,
              width: "40%",
            }}
          />
          <Typography
            variant="h4"
            paragraph
            sx={{
              color: "#4d82cb",
              fontWeight: 500,
            }}
          >
            Contact Us
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontWeight: 500 }}>
            mtxpk@cchmc.org
          </Typography>

          <TextField
            label="NAME"
            value={contactFormValues.name}
            onChange={handleChange("name")}
            margin="normal"
            sx={{
              width: { xs: "100%", md: "300px" },
            }}
          />
          <br />
          <TextField
            label="EMAIL"
            value={contactFormValues.email}
            onChange={handleChange("email")}
            margin="normal"
            sx={{
              width: { xs: "100%", md: "300px" },
            }}
          />
          <br />
          <TextField
            label="ROLE"
            value={contactFormValues.role}
            onChange={handleChange("role")}
            margin="normal"
            sx={{
              width: { xs: "100%", md: "300px" },
            }}
          />
          <br />
          <TextField
            label="INSTITUTION"
            value={contactFormValues.institution}
            onChange={handleChange("institution")}
            margin="normal"
            sx={{
              width: { xs: "100%", md: "300px" },
            }}
          />
          <br />
          <Button
            variant="contained"
            size="medium"
            color="primary"
            onClick={openEmailClientsWithDetails}
            sx={{
              float: "right",
              mt: 3,
              backgroundColor: "#4d82cb",
            }}
          >
            Send Email
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Contact;
